import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import Icons from "../../icons";

import "./styles.scss";
import UserImage from "../UserImage/index";
import { useModules } from "../../utils/modules";
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { fetchOrgRequest } from '@/common/sagas/orgListSaga';
const readEntityOrgId = (entity) => entity?.org_id ?? entity?.OrgId ?? null;
const readEntityId = (entity) => entity?.id ?? entity?.Id ?? null;

const UserMiniProfile = (props) => {
  const { isModuleEnabled } = useModules();
  const dispatch = useDispatch();
  const isOrg = props.type === 'org';
  const cachedUser = useSelector((state) => state.userList?.[props.userId]);
  const cachedOrg = useSelector((state) => state.orgList?.[props.userId]);
  const cachedEntry = isOrg ? cachedOrg : cachedUser;
  const user = props.user?.Data || cachedEntry;
  const userOrgId = readEntityOrgId(user);
  const userOrgName = useSelector((state) => (
    !isOrg && userOrgId != null ? state.orgList?.[userOrgId]?.name : undefined
  ));

  React.useEffect(() => {
    if (!isOrg && userOrgId != null && !userOrgName) {
      dispatch(fetchOrgRequest([userOrgId]));
    }
  }, [dispatch, isOrg, userOrgId, userOrgName]);

  React.useEffect(() => {
    if (isOrg && props.userId != null && !cachedOrg) {
      dispatch(fetchOrgRequest([props.userId]));
    }
  }, [dispatch, isOrg, props.userId, cachedOrg]);
  const sessionContext = useSelector(selectSessionContextOidc);
  const currentOrgId = sessionContext?.userView?.orgId ?? null;
  const entityOrgId = isOrg ? (readEntityId(user) ?? props.userId) : userOrgId;
  const isSameOrgAsCurrentUser = currentOrgId != null && entityOrgId != null
    && String(currentOrgId) === String(entityOrgId);

  const currentTeammember = !isOrg && isSameOrgAsCurrentUser;
  const b2bTeamMember = !isOrg && !isSameOrgAsCurrentUser;
  const currentOrg = isOrg && isSameOrgAsCurrentUser;
  const b2bOrg = isOrg && !isSameOrgAsCurrentUser;

  if (user && Object.keys(user).length) {
    const displayName = isOrg
      ? (user.OrganizationName || user.name || user.organization_name || "")
      : `${user.first_name || ""} ${
      user.last_name || ""
    }`.trim();
    const licenseNumber =
      isModuleEnabled("manage_profile.details.license_number") &&
      user.licenses &&
      user.licenses.filter((x) => x.state == props.wklocation).length > 0
        ? user.licenses.filter((x) => x.state == props.wklocation)[0].license_number
        : "";
    return (
      <div
        className={
          !props.isMultipleProfile ? "exz-userminiprofile-container" : ""
        }
      >
        <div className="colFlex alignMiddle">
          <div className="user-details">
            <div className="user-image">
              <UserImage
                profileUrl={user.profile_image}
                profileName={displayName}
                size="52"
              />
            </div>
            <div className="details-content">
              {displayName && (
                <strong>
                  {displayName}
                  {!isOrg && user.is_active === false && (
                    <span class="gray"> (Inactive)</span>
                  )}
                </strong>
              )}
              {!isOrg && !props.isMultipleProfile && user.job_title && (
                <label>{user.job_title}</label>
              )}
              {props.title && <label>{props.title}</label>}
            </div>
          </div>
          <div className="user-contacts">
            {!isOrg && userOrgName && (
              <div className="rowFlex alignMiddle">
                <Icons name="org" className="icon mr" /> {userOrgName}
              </div>
            )}
            {!isOrg && user?.phone && (
              <div className="rowFlex alignMiddle">
                <Icons name="mobile" className="icon mr" /> {user.phone}
              </div>
            )}
            {!isOrg && user?.email && (
              <div className="rowFlex alignMiddle">
                <Icons name="email" className="icon mr" />{" "}
                <a href={`mailto:${user.email}`}>{user.email}</a>
              </div>
              )}
              {!isOrg && user?.faxax && (
                <div className="rowFlex alignMiddle">
                  <Icons name="fax" className="icon mr" /> {user.fax}
                </div>
              )}
              {isOrg && user?.city && (
                <div className="rowFlex alignMiddle">
                  <Icons name="city" className="icon mr" /> {user.city}
                </div>
              )}
              {isOrg && user?.zip && (
                <div className="rowFlex alignMiddle">
                  <Icons name="zip" className="icon mr" /> {user.zip}
                </div>
              )}
              {!isOrg && licenseNumber != "" && (
                <div className="rowFlex alignMiddle">
                  <Icons name="userNum" className="userNum icon mr" />{" "}
                  {licenseNumber}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default UserMiniProfile;
